import React, { Component } from "react";
import * as aor from "react-admin";
import { connect } from "react-redux";
import { change } from "redux-form";
import { withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DeleteIcon from "@material-ui/icons/Delete";
import PersonIcon from "@material-ui/icons/PersonAdd";

import TranslatedText from "./TranslatedText";
import {
    getLoggedUserId,
    getUserCompanyRole,
    getPolicies
} from "../common/authClient";
import { POLICY_TICKETS } from "../common/rolesManagement";
import StatusChip from "./StatusChip";
import { TicketEventStatus } from "../common/statuses";

const styles = {
    button: {
        position: "relative",
        top: 24
    }
};

const StatusComponent = props => {
    return (
        <aor.Labeled label="resources.tickets.fields.status">
            <StatusChip
                source="status"
                record={props.record}
                translationRoot={"resources.tickets.status"}
            />
        </aor.Labeled>
    );
};

class TicketOwnership extends Component {
    state = {
        assigned: false,
        disabled: false,
        show_confirm_dialog: false,
        show_button: true
    };

    componentDidMount() {
        const is_assigned = this.props.record.user_id !== null;
        // Button is disabled if:
        // - Ticket status is done (no need to assign/remove user anymore)
        // - Ticket is in progress (already assigned to someone else) and you're a base user.
        // (Base users can only assign tickets to themselves and unassign if they're the operator)
        let is_disabled =
            this.props.record.status === TicketEventStatus.ticketDone ||
            (this.props.record.status === TicketEventStatus.ticketInProgress &&
                is_assigned &&
                this.props.record.user_id !== getLoggedUserId() &&
                !getPolicies(getUserCompanyRole()).includes(
                    POLICY_TICKETS.REMOVE_ASSIGNEE
                ));

        // Disabled if there is an installation linked
        if (is_assigned && this.props.record.installation_id) {
            is_disabled = true;
        }

        this.setState({ assigned: is_assigned, disabled: is_disabled });
    }

    assignOrRemoveOwner = () => {
        const new_state = !this.state.assigned;
        let new_assigner = null;
        if (new_state) {
            new_assigner = getLoggedUserId();
        }
        this.props.input.onChange(new_assigner);
        this.setState(
            prevState => {
                return {
                    assigned: !prevState.assigned,
                    show_confirm_dialog: false
                };
            } /*, () => {
            this.saveOwner(new_assigner);
        }*/
        );
    };

    /*
    saveOwner = (assigner) => {
        const { record: { id, user_id } } = this.props;
        const assigned = this.state.assigned;
        const user_id_update = assigner !== null ? assigner : user_id;
        const query = {
            id: id,
            data: { user_id: assigned ? user_id_update : null },
            previousData: {
                user_id: assigned ? null : user_id_update
            }
        };
        myRestClient("UPDATE", "tickets", query).then(
            result => {

            },
            error => {
                return [];
            }
        );
    };
    */

    handleCancel = () => {
        this.setState({ show_confirm_dialog: false });
    };

    handleOk = event => {
        event.preventDefault();
        this.assignOrRemoveOwner();
        // this.saveOwner();
    };

    handleClick = () => {
        if (this.state.assigned) {
            this.setState({ show_confirm_dialog: true });
        } else {
            this.assignOrRemoveOwner();
            // this.saveOwner();
        }
    };

    renderDialog() {
        return this.state.show_confirm_dialog ? (
            <Dialog
                disableBackdropClick
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.show_confirm_dialog}
            >
                <DialogTitle>
                    <b>
                        <TranslatedText resource_name="ra.actions.confirm" />
                    </b>
                </DialogTitle>
                <DialogContent>
                    <TranslatedText resource_name="resources.tickets.actions.confirm_remove_owner" />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCancel} color="primary">
                        <TranslatedText resource_name="ra.action.cancel" />
                    </Button>
                    <Button
                        onClick={this.handleOk}
                        variant="contained"
                        color="secondary"
                    >
                        <DeleteIcon />
                        <TranslatedText resource_name="ra.actions.remove" />
                    </Button>
                </DialogActions>
            </Dialog>
        ) : null;
    }

    render() {
        const resource_name_button = this.state.assigned
            ? "remove_owner"
            : "assign_to_me";
        return (
            <aor.FormDataConsumer>
                {({ formData }) => {
                    //FIXME: Verificare lato BE se possibile gestire il parametro aggiuntivo (con additional properties?)
                    //customer_url viene messo in formData quando apro la popup da Crea per inserirlo e poi faccio Annulla
                    //Questo manda in errore il salvataggio del ticket perchè passa customer_url tra i parametri
                    //Per evitarlo, se presente, devo toglierlo da formData
                    if (formData && "customer_url" in formData) {
                        delete formData["customer_url"];
                    }
                    return formData ? (
                        <React.Fragment>
                            <aor.Labeled label="resources.tickets.fields.user_id">
                                <aor.ReferenceField
                                    key={formData.user_id}
                                    record={formData}
                                    resource="users"
                                    basePath="/users"
                                    source="user_id"
                                    reference="users"
                                    linkType="show"
                                    allowEmpty
                                >
                                    <aor.TextField source="username" />
                                </aor.ReferenceField>
                            </aor.Labeled>
                            {this.state.show_button && (
                                <Button
                                    className={this.props.classes.button}
                                    color="primary"
                                    target="_blank"
                                    onClick={this.handleClick}
                                    disabled={this.state.disabled}
                                >
                                    {this.state.assigned ? (
                                        <DeleteIcon />
                                    ) : (
                                        <PersonIcon />
                                    )}
                                    <TranslatedText
                                        resource_name={`resources.tickets.actions.${resource_name_button}`}
                                    />
                                </Button>
                            )}
                            <div>
                                <StatusComponent record={formData} />
                            </div>
                            {this.renderDialog()}
                        </React.Fragment>
                    ) : null;
                }}
            </aor.FormDataConsumer>
        );
    }
}

const mapDispatchToProps = {
    change
};

export default connect(
    null,
    mapDispatchToProps
)(withStyles(styles)(TicketOwnership));



// WEBPACK FOOTER //
// ./src/components/TicketOwnership.js